import "./Buzon.css"
import { useEffect, useState } from "react";
import { getFriendRequests, getFriendsList } from '../../../Services/Inbox.js'

import Inbox from "./LeftBox/Inbox/Inbox.jsx";
import SearchContact from "./LeftBox/SearchContact/SearchContact.jsx";
import RequestList from "./LeftBox/RequestList/RequestList.jsx";
import ContactList from "./LeftBox/ContactList/ContactList.jsx";

import CreateMessage from "./RigthBox/CreateMessage/CreateMessage.jsx";
import ReadMessage from "./RigthBox/ReadMessage/ReadMessage.jsx";
import usePaging from "../../../Hooks/usePaging";
import DialogModal from "../../Modals/dialogModal.jsx"


var current = 1;
const Buzon = (props) => {

    const [selected, setSelected] = useState(0);
    const [selectedType, setSelectedType] = useState(null);
    const [friendListData, setFriendListData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);




    const loadFriendList = async (name="") => {
        let rsp = await getFriendsList({page: friendListPaging.current, name:name});


        if(rsp?.Error === false){
            setFriendListData(rsp.Data.data);

            if (rsp.Data.prev_page_url != null) {
                friendListPaging?.setIsPrevPage(true);
            } else {
                friendListPaging?.setIsPrevPage(false);
            }

            if (rsp.Data.next_page_url != null) {
                friendListPaging?.setIsNextPage(true);
            } else {
                friendListPaging?.setIsNextPage(false);
            }
        }else{
            setShowModal(true)
        }
    }

    const loadDataFrame = async () => {
        await loadFriendList();
    }


    useEffect(() => {
        loadDataFrame();
    }, [])

    const friendListPaging = usePaging(loadFriendList);


    return(
    <div className="frame buzon-frame">
                <DialogModal showModal={showModal} setShowModal={setShowModal}>
                    <h3> 
                        No se pudo cargar la lista de contactos.
                    </h3>
                </DialogModal>
        <div className="buzonMenu">
            <div className="buzon-tabs">
                <button className={`buzon-tab${selected === 0 ? ' active' : ''}`} onClick={() => { setSelected(0); setSelectedType(null); }}>Recibidos</button>
                <button className={`buzon-tab${selected === 1 ? ' active' : ''}`} onClick={() => { setSelected(1); setSelectedType(null); }}>Enviados</button>
                <button className={`buzon-tab${selected === 2 ? ' active' : ''}`} onClick={() => { setSelected(2); setSelectedType(null); }}>Agenda</button>
            </div>
            {
                    selected === 0 ? 
                    <Inbox current={current} setSelectedType={setSelectedType} selected={selected} setIsLoading={setIsLoading} isLoading={isLoading} key={selected}/>
                    :
                    selected === 1 ?
                    <Inbox current={current} setSelectedType={setSelectedType} selected={selected} setIsLoading={setIsLoading} isLoading={isLoading} key={selected}/>
                    :
                    selected === 2 ?
                    <ContactList paging={friendListPaging} list={friendListData} setRigthBoxState={setSelectedType} setIsLoading={setIsLoading} isLoading={isLoading}/>
                    :
                    <></>
            }
        </div>
        <div className="buzonCuerpo">
            {
                selectedType === null ?
                <></>
                :
                selectedType.type === 0  ?
                <CreateMessage id_for={selectedType.id} user={friendListData.find(item => item.id === selectedType.id)} usrData={props.usrData} selectedType={selectedType} setSelectedType={setSelectedType}/>
                :
                selectedType.type === 1 ?
                <ReadMessage messege={selectedType.messege} usrData={props.usrData} loadDataFrame={loadDataFrame} selected={selected} setSelectedType={setSelectedType} />
                :
                <></>
            }
        </div>
    </div>
    )
}

export default Buzon;